import { useGetClustersQuery } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/query';
import { clustersSelector } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/selectors';
import { type Cluster } from '@/packages/query-state/shared/types/clusters/ClustersResponse';
import { useActivePinIdSelector } from '@/packages/redux-state/store/slices/mapControls';

export function useGetClusterByActivePinId(): Cluster | undefined {
  const activePinId = useActivePinIdSelector();

  const { data: clusters } = useGetClustersQuery({ select: clustersSelector });

  return clusters?.find(item => item.id === activePinId);
}
